import React, { useState } from 'react';
import { HandThumbsUp, HandThumbsDown } from 'react-bootstrap-icons';
import { getOrCreateVoterKey, voteBlogPost } from '../../services/blogApi';

/**
 * Anonymous thumbs up/down for published posts.
 */
export default function BlogThumbs({ slug, initialUp = 0, initialDown = 0, colors }) {
  const [up, setUp] = useState(initialUp);
  const [down, setDown] = useState(initialDown);
  const [myVote, setMyVote] = useState(null);
  const [busy, setBusy] = useState(false);

  const muted = colors?.textSecondary || '#94a3b8';
  const text = colors?.text || '#e2e8f0';
  const border = colors?.border || 'rgba(148,163,184,0.25)';

  const cast = async (vote) => {
    if (busy) return;
    setBusy(true);
    try {
      const voterKey = getOrCreateVoterKey();
      const data = await voteBlogPost(slug, { vote, voterKey });
      setUp(data.thumbs_up);
      setDown(data.thumbs_down);
      setMyVote(data.your_vote);
    } catch (err) {
      console.error(err);
    } finally {
      setBusy(false);
    }
  };

  const btn = (active) => ({
    display: 'inline-flex',
    alignItems: 'center',
    gap: '0.4rem',
    padding: '0.45rem 0.85rem',
    borderRadius: '999px',
    border: `1px solid ${border}`,
    background: active ? 'rgba(59,130,246,0.15)' : 'transparent',
    color: active ? text : muted,
    cursor: busy ? 'wait' : 'pointer',
    fontSize: '0.9rem',
  });

  return (
    <div
      className="blog-thumbs"
      style={{
        display: 'flex',
        alignItems: 'center',
        gap: '0.75rem',
        marginTop: '2rem',
        paddingTop: '1.5rem',
        borderTop: `1px solid ${border}`,
      }}
    >
      <span style={{ color: muted, fontSize: '0.85rem', marginRight: '0.25rem' }}>Was this useful?</span>
      <button type="button" style={btn(myVote === 'up')} onClick={() => cast('up')} disabled={busy} aria-label="Thumbs up">
        <HandThumbsUp size={16} />
        {up}
      </button>
      <button type="button" style={btn(myVote === 'down')} onClick={() => cast('down')} disabled={busy} aria-label="Thumbs down">
        <HandThumbsDown size={16} />
        {down}
      </button>
    </div>
  );
}
